// @module Ames.RentFromAnywhere.RentFromAnywhere
// Single source of truth for "is this cart / order line a RENTAL line".
//
// Rental lines (added by the RFA grid / PDP) carry:
//   custcol_custom_rate              -> the NetScore rate field used ("custitem_nst_rrm_rt_daily", ...)
//   custcol_configurable_description -> "8 Days Rental", "30 Days Rental", ...
//   custcol_custom_price             -> the period total
// Configurable SETS (TTFINISH, COLFINISH, ...) also use custcol_custom_price and
// custcol_configurable_description (a list of components), so those two alone
// are NOT rental signals. Same rule as UE_Rental_Items.js (isRentalLineAt):
//   rental  <=>  custcol_custom_rate is set  OR  description matches "N Days Rental"
//           OR   (My Account, NetScore-created lines) a rental rate column > 0
define("Ames.RentFromAnywhere.RentalLine", ["underscore"], function (_) {
  "use strict";

  var DAYS_RENTAL = /(\d+)\s*Days?\s*Rental/i;
  var RATE_COLUMNS = ["custcol_nst_rrm_60_days", "custcol_nst_rrm_rt_daily", "custcol_nst_rrm_rt_weekly", "custcol_nst_rrm_rt_monthly", "custcol_nst_rrm_90_days"];

  // Value of a line option whatever shape the model gives it
  // (Backbone option model, plain object, or raw options array entry)
  function optionValue(line, id) {
    try {
      if (line && _.isFunction(line.getOption)) {
        var opt = line.getOption(id);
        if (opt) {
          var val = _.isFunction(opt.get) ? opt.get("value") : opt.value;
          if (val && typeof val === "object") val = val.internalid !== undefined ? val.internalid : val.label;
          if (val !== undefined && val !== null && val !== "") return val;
        }
      }
      var options = line && _.isFunction(line.get) ? line.get("options") : (line && line.options);
      var list = options && _.isFunction(options.toJSON) ? options.toJSON() : options || [];
      var hit = _.find(list, function (o) { return String(o.cartOptionId || o.id || "").toLowerCase() === id; });
      if (!hit) return null;
      var v = hit.value;
      if (v && typeof v === "object") v = v.internalid !== undefined ? v.internalid : v.label;
      return v === undefined || v === "" ? null : v;
    } catch (e) {
      return null;
    }
  }

  function isRentalLine(line) {
    if (!line) return false;
    if (optionValue(line, "custcol_custom_rate")) return true;
    var desc = optionValue(line, "custcol_configurable_description");
    if (desc && DAYS_RENTAL.test(String(desc))) return true;
    return _.some(RATE_COLUMNS, function (col) {
      var v = parseFloat(optionValue(line, col));
      return !isNaN(v) && v > 0;
    });
  }

  function rentalDays(line) {
    var desc = optionValue(line, "custcol_configurable_description");
    var m = desc && String(desc).match(DAYS_RENTAL);
    return m ? parseInt(m[1], 10) : null;
  }

  function cartHasRentalLines(liveOrder) {
    var lines = liveOrder && liveOrder.get("lines");
    return !!(lines && lines.models && _.some(lines.models, isRentalLine));
  }

  // Sum of the rental lines' amounts (deposit base)
  function rentalCharges(liveOrder) {
    var lines = liveOrder && liveOrder.get("lines");
    if (!lines || !lines.models) return 0;
    return _.reduce(lines.models, function (sum, line) {
      if (!isRentalLine(line)) return sum;
      var amount = parseFloat(line.get("amount"));
      if (isNaN(amount)) {
        var rate = parseFloat(line.get("rate")), qty = parseFloat(line.get("quantity")) || 1;
        amount = isNaN(rate) ? 0 : rate * qty;
      }
      return sum + amount;
    }, 0);
  }

  return {
    isRentalLine: isRentalLine,
    rentalDays: rentalDays,
    cartHasRentalLines: cartHasRentalLines,
    rentalCharges: rentalCharges,
    optionValue: optionValue
  };
});
